<template>
    <footer class="footer_wrp">
        <ul class="footer_nav">
            <li>
                <router-link to="/contact-us/" class="link"><span>Contact Us</span></router-link> &nbsp; / &nbsp;
            </li>
            <li><router-link to="/about-us/" class="link"><span>About Us</span></router-link> &nbsp; / &nbsp; </li>
            <li><router-link to="/faq/" class="link"><span>FAQ</span></router-link> &nbsp; / &nbsp; </li>
            <li><router-link to="/team/" class="link"><span> The Team</span></router-link> &nbsp; / &nbsp; </li>
            <li>
                <router-link to="/member/agreement/" class="link"><span>Member Agreement</span></router-link> &nbsp; /
                &nbsp;
            </li>
            <li>
                <router-link to="/privacy-policy/" class="link">Privacy Policy</router-link>
            </li>
        </ul>
        <div class="footer-copy">
            &copy; Lymphomap Inc. {{ year }}
        </div>
    </footer>
</template>

<script>
export default {
    name: 'appFooter',
    components: {
    },
    props: [],
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
/* Footer Css */

.footer_wrp {
    background: #171717;
    text-align: center;
    padding: 10px 0;
    font-family: 'Lato', sans-serif;
    width: 100%;
    line-height: 1.3;
    position: relative
}

.footer_wrp ul {
    margin: 0;
}

.footer_nav li {
    display: inline-block;
    vertical-align: middle;
    color: #e3e3e3;
    font-size: 16px;
    margin: 0 1px;
}

.footer_nav li a {
    color: #e3e3e3;
    font-size: 15px;
    font-weight: 400;
    transition: all 0.2s cubic-bezier(0.000, 0.000, 0.580, 1.000);
    -webkit-transition: all 0.2s cubic-bezier(0.000, 0.000, 0.580, 1.000);
    -moz-transition: all 0.2s cubic-bezier(0.000, 0.000, 0.580, 1.000);

    @media only screen and (max-width:767px) {
        font-size: 14px;
    }
}

.footer_nav li a:hover {
    font-weight: bold;
    text-decoration: none;
    color: #ffd400;
}

.footer-copy {
    color: #e3e3e3;
    font-size: 15px;
    font-weight: 400;
    margin-top: 5px;

    @media only screen and (max-width:767px) {
        font-size: 14px;
    }
}

.link {
    cursor: pointer;
}

/* Footer Css */
</style>